import { NgClass, NgIf } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  DoCheck,
  EventEmitter,
  Input,
  Output,
  ViewRef,
} from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormGroup } from '@angular/forms';


@Component({
    selector: 'gd-multi',
    template: `
    <div [formGroup]="form" class="spacing">
   <textarea  [rows]="5"
          [cols]="43"
  class="rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 
         text-sm text-gray-900 dark:text-gray-100 placeholder-gray-400 dark:placeholder-gray-500
         focus:ring-2 focus:ring-primary-500 focus:border-primary-500 p-3 resize-y shadow-sm
         transition duration-150 ease-in-out"
  style="background-color:#ffffff;color:#111827;-webkit-text-fill-color:#111827;"
  [ngClass]="{
    'border-red-500 focus:ring-red-500': reptextval && field?.name === 'AlertRepText'
  }"
  [formControlName]="field.name"
  [id]="field.name"
  rows="10"
  cols="140"
  [readOnly]="field.disabled"
  [placeholder]="field.value"
></textarea>
      <span
        style="padding-left: 20px"
        *ngIf="field.countbtn === 0 && field.name === 'comment0'"
        ><button type="button" kendobutton (click)="Addrow()">Add</button></span
      >
    </div>
    <div
      class="alert alert-danger my-1 p-2 fadeInDown animated fieldnot "
      style=" text-align: center;
  font-size:11px;"
      *ngIf="reptextval && field?.name === 'AlertRepText'"
    >
      Alert Rep Text is required.
    </div>
  `,
    styleUrls: ['./globalform.css'],
    imports: [
        FormsModule,
        ReactiveFormsModule,
        NgClass,
        NgIf,
    ]
})
export class MulitLineComponent implements DoCheck {
  @Input() field: any = {}
  @Input() form: UntypedFormGroup
  @Output() pushForm = new EventEmitter<any>()
  public reptextval = false
  get isValid() {
    return this.form.controls[this.field.name].valid
  }
  get isDirty() {
    return this.form.controls[this.field.name].dirty
  }

  constructor(private cdr: ChangeDetectorRef) {}
  ngDoCheck() {
    if (localStorage.getItem('repalert') === 'true') {
      this.reptextval = true
    } else {
      this.reptextval = false
    }
    setTimeout(() => {
      if (
        this.cdr !== null &&
        this.cdr !== undefined &&
        !(this.cdr as ViewRef).destroyed
      ) {
        this.cdr.detectChanges()
      }
    }, 250)
  }
  Addrow() {
    this.pushForm.emit({
      type: 'multiline',
      name: 'comment2',
      label: '',
      value: 'new line here',
      required: false,
    })
  }
}
